export const TennisHdpSingle = `
{{var favouritePeriod = data.favouritePeriod;}}
{{var period = parseInt(data.period);}}
{{var isSelectedPeriod = period > 0;}}
{{var firstPeriod = isSelectedPeriod ? period : 0;}}
{{var event_count = 0;}}
{{var isLiveEvent = data.isLiveEvent;}}
{{var options = data.options;}}
{{? data.sports}}
{{var isMultipleSports = data.sports.length > 1;}}
{{~data.sports :sp:sp_index}}
{{? isMultipleSports}}<div class="mul-sp-name"><span><li class="sp {{=utils.convertToSportIcon(sp[1])}} sp{{=sp[0]}}"></li></span>{{=i18n('sports', sp[1])}}</div>{{?}}
{{var ot = data.ot;}}
{{var isParlay = (data.isParlay || data.isParlayMarket);}}
{{var isEsport = sp[0] == 12;}}
{{var sportName = sp[1];}}
{{var isShowLiveTv = data.isShowLiveTv;}}
{{var isEnableSignUp = data.isEnableSignUp;}}
{{var isBlockedLiveSport = data.isBlockedLiveSport;}}
{{var blockedLiveLeagues = data.blockedLiveLeagues;}}
{{var periodsRightLayout = data.periodsRightLayout;}}
{{var isBrandSupportLiveCenter = data.isBrandSupportLiveCenter;}}
{{var altMainLabel = data.altMainLabel && (isSelectedPeriod ? Number(firstPeriod) !== 1 : periodsRightLayout[0] !== 1) ? (data.altMainLabel + "_".concat(isSelectedPeriod ? firstPeriod : periodsRightLayout[0])) : "";}}
{{var periodsDescription = data.periodsDescription;}}
{{var homeAwayLabel = data.homeAwayLabel;}}
{{var homeAwayDesc = homeAwayLabel.description;}}
{{var isTennis = sp[0] == 33;}}
{{var hasDrawML = sp[7];}}

<div class='single-line {{? data.favourite}} fav-container {{?}} {{? isMultipleSports}} mul-sp {{?}}'>
    <div class="freeze-table-header"></div>
    <table class="events tennis events-header{{? options.isParlayMarket}} isParlayMarket{{?}} sp{{=sp[0]}}">
      <tr>
          <td class="col-icons main-icons border-left border-bottom col-border-left"></td>
          <td class="col-time main-time border-bottom-right">{{=i18n('Time')}}</td>
          <td class='col-fav main-fav border-bottom'>&nbsp</td>
          <td class='col-name main-name border-bottom-right'><span>{{=i18n('Event')}}</span></td>
          <td class="hdp single-hdp main-hdp border-bottom-right"><span class="period-hdp">{{=i18n('HDP')}}</span> <span>{{=i18n('Sets')}}</span></td>
          <td class="odds main-odds border-bottom-right">{{=i18n(homeAwayDesc[0])}}</td>
          <td class="odds main-odds border-bottom-right">{{=i18n(homeAwayDesc[1])}}</td>
          <td class="hdp single-hdp main-hdp border-bottom-right"><span class="period-hdp">{{=i18n('OU')}}</span> <span>{{=i18n('Sets')}}</span></td>
          <td class="odds main-odds border-bottom-right">{{=i18n('Over')}}</td>
          <td class="odds main-odds border-bottom-right">{{=i18n('Under')}}</td>

          <td class="hdp single-hdp main-hdp border-bottom-right"><span class="period-hdp">{{=i18n('HDP')}}</span> <span>{{=i18n('Games')}}</span></td>
          <td class="odds main-odds border-bottom-right">{{=i18n(homeAwayDesc[0])}}</td>
          <td class="odds main-odds border-bottom-right">{{=i18n(homeAwayDesc[1])}}</td>
          <td class="hdp single-hdp main-hdp border-bottom-right"><span class="period-hdp">{{=i18n('OU')}}</span> <span>{{=i18n('Games')}}</span></td>
          <td class="odds main-odds border-bottom-right">{{=i18n('Over')}}</td>
          <td class="odds main-odds border-bottom-right">{{=i18n('Under')}}</td>
          <td class="col-more main-more border-bottom-right border-left col-border-right" title="{{=i18n('More')}}">&nbsp;</td>
      </tr>
    </table>
    {{var leagues = sp[2];}}
    {{var images = {};}}
    {{~leagues :lg:lg_index}}
    {{var leagueName = lg[1];}}
    {{var leagueId = lg[0];}}
    {{var isBlockedLiveLeague = blockedLiveLeagues.indexOf(leagueId) > -1;}}
    <div class="league" id='lg{{=leagueId}}'>
        <a class="bookmark "><i data-league-id="{{=leagueId}}" class='fav  icon'></i></a>
        <div class="fav-custom-tooltip ">
            <div class="tooltip-wrapper">
                <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
            </div>
        </div>
        <span>
        {{var originalLeagueName = lg[4] ? lg[4] : leagueName;}}
        {{=leagueName}}
        </span>
        <a class="refresh-odds" data-live="{{=data.isLive}}"><i class='icon refresh-odds'></i></a>
    </div>
    <div>
    {{var events = lg[2] || [];}}
    {{var eParentLeague = fetchParentId(events) || [];}}
    {{var parentEvents = events.filter(function(e){ return e[28]==0});}}
    {{var notParentEvents = events.filter(function(e){ return e[28] != 0});}}
    {{~eParentLeague :parentEvent:parentEventIndex}}
        {{var periodParent = 0;}}
        {{var evParent = parentEvents.find(function(ev) {return ev[0] === parentEvent}) || [];}}
        {{var childEvents = notParentEvents.filter(function(e){ return e[28] === parentEvent});}}
        {{var isSetChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Sets";});}}
        {{var isGameChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Games";});}}
        {{var isRegularChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Regular";});}}
        {{? evParent.length === 0 && !isRegularChildEvent}}
            {{evParent = notParentEvents.find(function(ev) { return ev[28] === parentEvent && (ev[27] === "Sets");}) || [];}}
            {{childEvents = notParentEvents.filter(function(ev) { return ev[28] === parentEvent && ev[27] === "Games";});}}        
        {{?}}
        {{var groupEvents = events.filter(function(e){ return e[28] == parentEvent || e[0] == parentEvent});}}
        {{var periods = groupEvents.reduce(function(pe, e){ return pe.concat(Object.keys(e[8]));}, []);}}
        {{var finalPeriods = data.favourite && favouritePeriod ? [favouritePeriod] : [...new Set(periods)];}}
        {{~finalPeriods :p:pIndex}}
        {{periodParent = p;}}
        {{var parentMoreBetCounted = 0;}}
        {{? childEvents.length > 0 }}
            {{var childEventSamePeriod = childEvents.filter(function(e){ return Object.keys(e[8]).includes(p);});}}
            {{? (isSetChildEvent && !isGameChildEvent) || (childEvents.length > 0 && evParent.length > 0 && childEventSamePeriod.length === 0 && Object.keys(evParent[8]).includes(p))}}
                {{childEventSamePeriod.unshift(evParent);}}
            {{?}}
        {{??}}
            {{var childEventSamePeriod = [evParent];}}
        {{?}}
        {{var isRegularEventParent = evParent && evParent[27] === "Regular";}}
        {{var isSetEventParent = evParent && evParent[27] === "Sets";}}
        {{var parentEventPeriod = evParent && evParent[8] ? evParent[8][p] : [];}}
        {{var _moreBetsMLParentCount = 0;}}
        {{? parentEventPeriod && parentEventPeriod[2] && (isRegularEventParent || isSetEventParent)}}
            {{_moreBetsMLParentCount = _moreBetsMLParentCount + 1;}}
        {{?}}

        {{~childEventSamePeriod :ev:evIndex}}
        {{var periodChild = p;}}
        {{var {isRegularEvent, isSetEvent, isGameEvent, isGameEventParent} = getTypeEventTennis(ev, evParent);}}
        {{var evSetsId = getEventSetsId(evParent, ev);}}

        {{? evParent[0] && periodParent == periodChild}}
          {{parentMoreBetCounted = parentMoreBetCounted + 1;}}
        {{?}}

        {{var isCountMoreBetsMLParentSet = !(parentEventPeriod && parentEventPeriod[2] && isSetEventParent && isSetEvent); }}
        <table class="events tennis no-select events-list single-mode sp{{=sp[0]}} {{=isParlay?'parlay':''}} border-bottom" id="e{{=(parentMoreBetCounted == 1 && parentEvent[0] != ev[0]) ? parentEvent[0]: 0}}_{{=ev[0]}}_{{=p}}" >
            
            {{var sets = isSetEvent ? ev[8][p] : (isSetEventParent || isRegularEventParent ? evParent[8][p] : []);}}
            {{var regular = isRegularEvent ? ev[8][p] : (isRegularEventParent && !isSetEvent ? evParent[8][p] : [] );}}
            {{var setsEvent = isSetEvent ? ev[8][p] : [];}}    
            {{var periodEvent = evParent && evParent[0] !== ev[0] && ev[8] && ev[8][p] ? ev[8][p] : 0;}}
            {{var parentPeriod = evParent && evParent[8] && evParent[8][p] ? evParent[8][p] : 0;}}
            {{var countMoreBetParent = parentMoreBetCounted == 1 && isCountMoreBetsMLParentSet ? _moreBetsMLParentCount: 0;}}
            {{var _moreBetsCount = ev[7];}}
            {{? period === 0 && !data.favourite}}
                {{var periodEventCount = periodEvent && periodEvent[8] ? periodEvent[8] : 0;}}
                {{var parentPeriodEventCount = parentMoreBetCounted == 1 ? (parentPeriod && parentPeriod[8] ? parentPeriod[8] : 0) : 0;}}
                {{_moreBetsCount = parseInt(periodEventCount) + (evParent.length > 0 ? parseInt(parentPeriodEventCount) : 0) + countMoreBetParent;}}
            {{??}}
                {{? evParent && evParent.length > 0 && evParent[0] !== ev[0]}}
                    {{_moreBetsCount = _moreBetsCount + evParent[7] + (data.favourite ? countMoreBetParent : 0);}}
                {{?}}
            {{?}}
            {{var event_count = event_count + 1;}}
            
            {{var haftTimePeriods = {};}}
            {{?isGameEventParent && !isGameEvent}}
                {{haftTimePeriods["ht" + p] = evParent[8][p];}}
            {{?}}

            {{?isGameEvent || isRegularEvent }}
                {{haftTimePeriods["ht" + p] = ev[8][p];}}
            {{??}}
                {{haftTimePeriods["ht" + p] = [];}}
            {{?}}

            {{? setsEvent && setsEvent[2] && !isGameEvent}}
                {{var _moreBetsCount = _moreBetsCount + 1;}}
            {{?}}

            {{var games = isGameEvent ? ev[8][p] : (isGameEventParent || (isRegularEventParent && !isSetEvent) ? evParent[8][p] : []);}}

            {{? games && games[2] && !isRegularEvent && !ev[30]}}
                {{var _moreBetsCount = _moreBetsCount + 1;}}
            {{?}}

            {{? isSelectedPeriod && (regular && regular[2])}}
                {{var _moreBetsCount = _moreBetsCount + 1;}}
            {{?}}

            {{? ht && ht[2] && !isRegularEventParent && !isSetEventParent}}
                {{var _moreBetsCount = _moreBetsCount + 1;}}
            {{?}}

            {{var ht = haftTimePeriods[Object.keys(haftTimePeriods)[0]];}}
            {{var ht2 = haftTimePeriods[Object.keys(haftTimePeriods)[1]];}}
            {{var ht3 = haftTimePeriods[Object.keys(haftTimePeriods)[2]];}}

            {{var minLine = ev[3] > 0 ? Math.min(ev[3], data.maxLines) : data.maxLines;}}
            {{var setHDP = !isRegularEvent && sets && sets[0] || [];}}
            {{var setOU = !isRegularEvent && sets && sets[1] || [];}}

            {{var haftTimeLines = {};}}
            {{~Object.keys(haftTimePeriods) :htKey:ht_index}}
              {{haftTimeLines[htKey + "HDP"] = (haftTimePeriods[htKey][0] || []);}}
              {{haftTimeLines[htKey + "OU"] = (haftTimePeriods[htKey][1] || []);}}
            {{~}}

            {{var gamesHDP = haftTimeLines["ht" + p + "HDP"] || [];}}
            {{var gamesOU = haftTimeLines["ht" + p + "OU"] || [];}}

            {{var indexMainLineFtHDP = sets && sets[7] && sets[7][0] || 0;}}
            {{var indexMainLineFtOU = sets && sets[7] && sets[7][1] || 0;}}
            {{var indexMainLineHtHDP = isRegularEvent ? regular && regular[7] && regular[7][0] || 0 : games && games[7] && games[7][0] || 0;}}
            {{var indexMainLineHtOU = isRegularEvent ? regular && regular[7] && regular[7][1] || 0 : games && games[7] && games[7][1] || 0;}}

            {{var indexMainLine = Math.max(indexMainLineFtHDP, indexMainLineFtOU, indexMainLineHtHDP, indexMainLineHtOU, 0);}}
            
            <!--Calculate the _moreBetsCount value when sport is eSport -->
            {{var numberOfDisplayedLine = Math.min(Math.max(setHDP.length, setOU.length, gamesHDP.length, gamesOU.length), data.maxLines) || 1;}}
            
            {{var lines = new Array().init(Math.min(minLine, data.maxLines, numberOfDisplayedLine));}}
            {{var isRegularLeft = regular && regular[2];}}
            {{var isRegularRight = (regular && regular[0]) || (regular && regular[1]);}}
            {{var statusPeriodLeftSide = (sets && sets[11]) || (isRegularLeft && regular[11]) ? "status_" + (sets[11] || regular[11]) : "";}}
            {{var statusPeriodRightSide = (games && games[11]) || (isRegularRight && regular[11]) ? "status_" + (games[11] || regular[11]) : "";}}
            {{var setEventId =  ((isRegularEvent && isRegularLeft) || isSetEvent) ? ev[0] : ((isRegularEventParent && isRegularLeft) || isSetEventParent) ? evParent[0] : 0;}}
            {{var gameEventId = ((isRegularEvent && isRegularRight) || isGameEvent) ? ev[0] : ((isRegularEventParent && isRegularRight) || isGameEventParent) ? evParent[0] : 0;}}
            
            {{~lines :line:line_index}}

            {{var _fthdp = setHDP.length > (line - (indexMainLine - indexMainLineFtHDP)) && (line - (indexMainLine - indexMainLineFtHDP)) >= 0 && setHDP[line - (indexMainLine - indexMainLineFtHDP)];}}
            {{var isFTHDPOnline = _fthdp && _fthdp[2] != '';}}
            
            {{var _ftou = setOU.length > (line - (indexMainLine - indexMainLineFtOU)) && (line - (indexMainLine - indexMainLineFtOU)) >= 0 && setOU[line - (indexMainLine - indexMainLineFtOU)];}}
            {{var isFTOUOnline = _ftou && _ftou[0] != '';}}
            
            {{var _hthdp = gamesHDP.length > (line - (indexMainLine - indexMainLineHtHDP)) && (line - (indexMainLine - indexMainLineHtHDP)) >= 0 && gamesHDP[line - (indexMainLine - indexMainLineHtHDP)];}}
            {{var isHTHDPOnline = _hthdp && _hthdp[2] != '';}}

            {{var _htou = gamesOU.length > (line - (indexMainLine - indexMainLineHtOU)) && (line - (indexMainLine - indexMainLineHtOU)) >= 0 && gamesOU[line - (indexMainLine - indexMainLineHtOU)];}}
            {{var isHTOUOnline = _htou && _htou[0] != '';}}
                        
            {{var isMainLine = (line == indexMainLine);}}
            {{var numberLine = (!isMainLine && line_index == 0) || lines.length >= 2 ? lines.length : 1;}}
            {{var isValidPeriod = _fthdp || _ftou || _hthdp || _htou;}}
            {{var teamNameEv1 = evParent.length > 0 && !isSetEvent ? evParent[1] :ev[1];}}
            {{var teamNameEv2 = evParent.length > 0 && !isSetEvent ? evParent[2] :ev[2];}}
            {{? isValidPeriod || line === 0 }}
            <tr class='{{=event_count%2==0?"even":"odd"}} main-mkline {{=isMainLine && hasDrawML ? "main-line-draw" : ""}} e{{=isSetEventParent ? evParent[0] : ev[0]}}_{{=p}}' id="e{{=ev[0]}}_{{=_fthdp[8] ? _fthdp[8] : _hthdp[8] }}" {{? _moreBetsCount > 0}} data-eid="{{=(parentMoreBetCounted == 1 && evParent[0] != ev[0]) ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}" {{?}} data-pid="{{=p}}">
                <td class='col-icons main-icons border-left col-border-left'>
                </td>
                {{?line_index == 0}}
                <td class='col-time main-time border-right' rowspan='{{=numberLine}}'>              
                    {{? ev[5]}}
                        {{? ev[9]}}
                            <span>{{=ev[9][0]}}-{{=ev[9][1]}}</span>
                        {{??}}
                            {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                        {{?}}
                        {{? ev[16]}}
                            <span class='liveInfo'>{{=i18n(ev[16])}} {{=ev[15]||''}}</span>
                        {{??}}
                            <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                        {{?}}
                    {{??}}
                        {{? ev[6] && !isBlockedLiveSport && !isBlockedLiveLeague}}
                            <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                            {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                        {{??}}
                            <span>{{=moment(new DateTZ(ev[4])).format(i18n('MM/DD'))}}</span>
                            <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                        {{?}}
                    {{?}}              
                </td>
                {{?}}
                <td class='col-fav main-fav'>
                    {{? isMainLine}}
                    <a class="bookmark" data-event-id="{{=evParent[0] || 0 }}_{{=ev[0]}}_{{=p}}"><i class='fav icon'></i></a>
                    <div class="fav-custom-tooltip ">
                        <div class="tooltip-wrapper">
                            <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
                        </div>
                    </div>
                    {{?}}
                </td>
                <td class='{{=(_fthdp || _hthdp)&&(_fthdp[6]||_fthdp[5]||_hthdp[5]||_hthdp[6])? "": "no-underdog"}} col-name main-name border-right {{=ev[18] && ev[19] ? "lc-icons": ev[19] ? "live-tv": ev[18] ?  "live-c" : ""  }}'
                    data-live="{{=ev[20]}}"
                    data-event="{{=ev[0]}}"
                    data-league-id="{{=leagueId}}"
                    data-home-team="{{=ev[1]}}"
                    data-away-team="{{=ev[2]}}"
                    data-sport-name="{{=sportName}}"
                >
                    {{? isMainLine}}
                        {{? !(ev[27] && ev[27].toLowerCase() === 'regular' && parseInt(p) === 0 && isLiveEvent)}}
                            <div class="grading-unit-container">
                                <span class="period-name">({{=getPeriodsName(periodsDescription, sp[0], p, false)}})<span>
                            </div>
                        {{?}}
                        <div class="team-name-container">
                            <span class='{{=(_fthdp && _fthdp[5] || _hthdp && _hthdp[5]) ? "favSel": "sel"}}' title="{{=teamNameEv1}}">            
                                    {{=teamNameEv1}}
                            </span>
                            <span class='{{=(_fthdp && _fthdp[6] || _hthdp && _hthdp[6]) ? "favSel": "sel"}}' title="{{=teamNameEv2}}">
                                    {{=teamNameEv2}}
                            </span>
                        </div>
                    {{??}}
                        <span>&nbsp;</span><span>&nbsp;</span>
                    {{?}}
                </td>
                <td class='hdp single-hdp main-hdp hdp-border border-right {{=statusPeriodLeftSide}}' data-eventid="{{=setEventId}}">
                    <span class='hdp'>{{=isFTHDPOnline ? _fthdp[2].formatSeparators() : '&nbsp;'}}</span>
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-eventid="{{=setEventId}}">
                    {{? isFTHDPOnline}}
                    <a class="odds {{=_fthdp[3] < 0 ? 'fav neg' : ''}}"
                      data-oddsid="{{=_fthdp[7]}}"
                      data-date="{{=ev[4]}}"
                      data-pl-res="{{=ev[22]}}"
                      data-team-type="{{=ev[11][0]}}"
                      id="{{=evSetsId}}|{{=p}}|2|0|{{=_fthdp[8]?1:0}}|{{=_fthdp[1]}}">
                      {{? ot === OddsFormat.American}}
                            <span>{{? _fthdp[3] > 0}}+{{?}}{{=_fthdp[3]}}</span>
                        {{??}}
                            <span>{{=_fthdp[3].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}&nbsp;
                    {{?}}
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-eventid="{{=setEventId}}">
                    {{? isFTHDPOnline}}
                    <a class="odds {{=_fthdp[4] < 0 ? 'fav neg' : ''}}"
                      data-oddsid="{{=_fthdp[7]}}"
                      data-date="{{=ev[4]}}"
                      data-pl-res="{{=ev[22]}}"
                      data-team-type="{{=ev[11][1]}}"
                      id="{{=evSetsId}}|{{=p}}|2|1|{{=_fthdp[8]?1:0}}|{{=_fthdp[0]}}"
                      >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _fthdp[4] > 0}}+{{?}}{{=_fthdp[4]}}</span>
                        {{??}}
                            <span>{{=_fthdp[4].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}&nbsp;
                    {{?}}
                </td>
                <td class='hdp single-hdp main-hdp hdp-border border-right {{=statusPeriodLeftSide}}' data-eventid="{{=setEventId}}">
                    <span>{{=isFTOUOnline ? _ftou[0].formatSeparators(): '&nbsp;'}}</span>
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-eventid="{{=setEventId}}" data-eventid="{{=setEventId}}">
                    {{? isFTOUOnline}}
                    <a class="odds {{=_ftou[2] < 0 ? 'fav neg' : ''}}"
                      data-oddsid="{{=_ftou[4]}}"
                      data-date="{{=ev[4]}}"
                      data-pl-res="{{=ev[22]}}"
                      data-team-type="{{=ev[11][0]}}"
                      id="{{=evSetsId}}|{{=p}}|3|3|{{=_ftou[5]?1:0}}|{{=_ftou[1]}}"
                      >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _ftou[2] > 0}}+{{?}}{{=_ftou[2]}}</span>
                        {{??}}
                            <span>{{=_ftou[2].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}
                    &nbsp;
                    {{?}}
                </td>
                <td class="odds main-odds border-right {{=statusPeriodLeftSide}}" data-eventid="{{=setEventId}}">
                    {{? isFTOUOnline}}
                    <a class="odds {{=_ftou[3] < 0 ? 'fav neg' : ''}}"
                      data-oddsid="{{=_ftou[4]}}"
                      data-date="{{=ev[4]}}"
                      data-pl-res="{{=ev[22]}}"
                      data-team-type="{{=ev[11][1]}}"
                      id="{{=evSetsId}}|{{=p}}|3|4|{{=_ftou[5]?1:0}}|{{=_ftou[1]}}"
                      >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _ftou[3] > 0}}+{{?}}{{=_ftou[3]}}</span>
                        {{??}}
                            <span>{{=_ftou[3].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}
                    &nbsp;
                    {{?}}
                </td>
                <td class='hdp single-hdp main-hdp hdp-border border-right {{=statusPeriodRightSide}}' data-eventid="{{=gameEventId}}">
                    <span class='hdp'>{{=isHTHDPOnline ? _hthdp[2].formatSeparators() : '&nbsp;'}}</span>
                </td>
                <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-eventid="{{=gameEventId}}">
                    {{? isHTHDPOnline}}
                    <a class="odds {{=_hthdp[3] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_hthdp[7]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][0]}}"
                    id="{{=ev[0]}}|{{=p}}|2|0|{{=_hthdp[8]?1:0}}|{{=_hthdp[1]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _hthdp[3] > 0}}+{{?}}{{=_hthdp[3]}}</span>
                        {{??}}
                            <span>{{=_hthdp[3].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}&nbsp;
                    {{?}}
                </td>
                <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-eventid="{{=gameEventId}}">
                    {{? isHTHDPOnline}}
                    <a class="odds {{=_hthdp[4] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_hthdp[7]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][1]}}"
                    id="{{=ev[0]}}|{{=p}}|2|1|{{=_hthdp[8]?1:0}}|{{=_hthdp[0]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _hthdp[4] > 0}}+{{?}}{{=_hthdp[4]}}</span>
                        {{??}}
                            <span>{{=_hthdp[4].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}&nbsp;
                    {{?}}
                </td>
                <td class='hdp single-hdp main-hdp hdp-border border-right {{=statusPeriodRightSide}}' data-eventid="{{=gameEventId}}">
                    <span>{{=isHTOUOnline ? _htou[0].formatSeparators(): '&nbsp;'}}</span>
                </td>
                <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-eventid="{{=gameEventId}}">
                    {{? isHTOUOnline}}
                    <a class="odds {{=_htou[2] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_htou[4]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][0]}}"
                    id="{{=ev[0]}}|{{=p}}|3|3|{{=_htou[5]?1:0}}|{{=_htou[1]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _htou[2] > 0}}+{{?}}{{=_htou[2].formatSeparators()}}</span>
                        {{??}}
                            <span>{{=_htou[2].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}
                    &nbsp;
                    {{?}}
                </td>
                <td class="odds main-odds border-right {{=statusPeriodRightSide}}" data-eventid="{{=gameEventId}}">
                    {{? isHTOUOnline}}
                    <a class="odds {{=_htou[3] < 0 ? 'fav neg' : ''}}"
                    data-oddsid="{{=_htou[4]}}"
                    data-date="{{=ev[4]}}"
                    data-pl-res="{{=ev[22]}}"
                    data-team-type="{{=ev[11][1]}}"
                    id="{{=ev[0]}}|{{=p}}|3|4|{{=_htou[5]?1:0}}|{{=_htou[1]}}"
                    >
                        {{? ot === OddsFormat.American}}
                            <span>{{? _htou[3] > 0}}+{{?}}{{=_htou[3]}}</span>
                        {{??}}
                            <span>{{=_htou[3].formatSeparators()}}</span>
                        {{?}}
                    </a>
                    {{??}}
                    &nbsp;
                    {{?}}
                </td>
                <td class='col-more main-more border-right col-border-right'>
                  {{? isMainLine}}    
                    <div class='more-content'>
                        {{? !isBlockedLiveSport && !isBlockedLiveLeague}}
                            {{? ev[18] && isBrandSupportLiveCenter}}
                            <!-- Has live center -->
                            <span class="icons live-center-icon">
                                <i class="live-ct"
                                data-live="{{=ev[20]}}"
                                data-event="{{=ev[0]}}"
                                data-league-id="{{=leagueId}}"
                                data-home-team="{{=ev[1]}}"
                                data-away-team="{{=ev[2]}}"
                                data-sport-name="{{=sportName}}"
                                data-league-name="{{=leagueName}}"
                                >
                                </i>
                                <div class="custom-tooltip">
                                <div class="tooltip-wrapper">
                                    <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                    {{? isEnableSignUp}}
                                    <span class="tooltip-text">{{=i18n('or')}}</span>
                                    <a id="{{=TooltipActions.SIGNUP}}" class="tooltip-link">{{=i18n('Sign up')}}</a>
                                    {{?}}
                                    <span class="tooltip-text">{{=i18n('to access our Live Center')}}</span>
                                </div>
                                </div>
                            </span>
                            {{?}}
                            {{? isShowLiveTv && ev[19] }} 
                            <!-- Has live tv -->
                            <span class="icons live-tv-icon">
                                <i class="live-tv"
                                data-live="{{=ev[20]}}"
                                data-event="{{=ev[0]}}"
                                data-league-id="{{=leagueId}}"
                                data-home-team="{{=ev[1]}}"
                                data-away-team="{{=ev[2]}}"
                                data-sport-name="{{=sportName}}"
                                >
                                </i>
                                <div class="custom-tooltip">
                                <div class="tooltip-wrapper">
                                    <a id="{{=TooltipActions.SIGNIN}}" class="tooltip-link">{{=i18n('Sign in')}}</a>
                                    <span class="tooltip-text">{{=i18n('to access our Live TV')}}</span>
                                </div>
                                </div>
                            </span>
                            {{?}}
                        {{?}}
                        
                        {{? _moreBetsCount > 0}}
                            <span id='more_{{=(parentMoreBetCounted == 1 && evParent[0] != ev[0]) ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}' class='more' data-eid="{{=(parentMoreBetCounted == 1 && evParent[0] != ev[0]) ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}" data-pid="{{=p}}">
                                <span class='more-loading'><i class='fa fa-sync fa-spin'></i></span>
                                <span class='sign'>+</span>
                                <span class="more-count">
                                    {{=_moreBetsCount}}
                                </span>
                            </span>
                        {{?}}
                    </div>
                  {{?}}  
                </td>
              </tr>
            {{?}}
            {{~}}
            <tr class="more-bets {{=event_count%2==0?"even":"odd"}}" id="e{{=(parentMoreBetCounted == 1 && evParent[0] != ev[0]) ? evParent[0] : 0}}_{{=ev[0]}}_{{=p}}_more"><td colspan="17" class="more-bets"></td></tr>
            </table>
          {{~}}
        {{~}}
        {{~}}<!--Events-->
        </div>
        {{~}}<!--Leagues-->
        {{? leagues.length ==0}}
            <div class="no-event">{{=i18n('No Events')}}</div>
        {{?}}
    </div>
    {{~}}<!--Sports-->
{{?}}
`;


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisHdpSingle.js